module.exports = __webpack_public_path__ + "static/media/call.d68fafa8.svg";